<template>
  <section class="relative pb-0">
    <tilted-background :disabled="false" background-color="white" :below-tilt-color="belowBackgroundColor">
      <div class="container pt-16 pb-24 m:pb-32">
        <div class="text-center">
          <b-headline
            type="h1"
            typography="h2"
            class="mb-6 l:mb-8"
            v-html="this.spaceB2b ? $t('headlineB2b') : $t('headline')"
          />
          <div class="relative w-fit-content m-auto">
            <avatar-image :space-b2b="spaceB2b" />
            <arrow-image />
          </div>
        </div>
      </div>
    </tilted-background>
  </section>
</template>

<script>
import TiltedBackground from "@/component-library/tilted-background"
import AvatarImage from "@/pages/spaces/join-page/components/avatar-image"
import ArrowImage from "@/pages/spaces/join-page/components/arrow-image"
import BHeadline from "@/component-library/b-headline"

export default {
  name: "AvatarFriends",
  components: {
    TiltedBackground,
    BHeadline,
    AvatarImage,
    ArrowImage
  },
  props: {
    friends: {
      type: Array,
      default: () => []
    },
    spaceB2b: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    belowBackgroundColor() {
      return this.spaceB2b ? "#F1F6F4" : "#E9E3FF"
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Join a <span class='text-blue'>free</span>, shared Space on Blinkist!",
        headlineB2b: "Join a shared Space on Blinkist!"
      },
      de: {
        headline: "Tritt einem <span class='text-blue'>kostenlosen</span> Space bei Blinkist bei!",
        headlineB2b: "Tritt einem Space bei Blinkist bei!"
      }
    }
  }
}
</script>
